'use strict';

import angular from 'angular';

export default class MemAtrCtrl {
  constructor($stateParams, $location, LoaderSvc, ToastrSvc,
    MemAtrTypeSvc, MemAtrSvc) {
    LoaderSvc.start('Loading Member Information...');
    var that = this;
    var groupId = $stateParams.groupId || $stateParams.ctxId;
    this.groupId = Number(groupId); // convert to number for disable link check
    var personId = $stateParams.perId;
    this.personId = Number(personId);

    // form values
    this.submitText = 'Update Member Information';
    var selectAtrTypes = [];

    // toggle edit form
    that.editMemAtr = false;
    that.editMemAttributes = function() {
      // get select options
      for(var j in selectAtrTypes) {
        var sat = selectAtrTypes[j];

        MemAtrTypeSvc.getOptions({groupId, id: sat.id}).$promise
          .then(function(options) { // eslint-disable-line no-loop-func
            sat.selectOptions = options;
          });
      }
      that.editMemAtr = true;
    };
    that.viewMemAttributes = function() {
      that.editMemAtr = false;
    };
    that.cancel = that.viewMemAttributes;


    function submit() {
      LoaderSvc.start('Updating Member Information...');
      var updateFlag = false;
      var memAtrDiffs = {};
      // compare for diffs
      for(var ma in that.model) {
        if(that.model[ma] !== that.memAtr[ma]) {
          updateFlag = true;

          memAtrDiffs[ma] = that.model[ma];
        }
      }
      if(!updateFlag) {
        ToastrSvc.info('No Member Attribute Updates');
        return LoaderSvc.stop();
      }

      return MemAtrSvc.set({groupId, id: personId}, memAtrDiffs).$promise
        .then(function(updatedMemAtr) {
          that.editMemAtr = false;
          that.memAtr = updatedMemAtr;
          that.model = angular.copy(updatedMemAtr);
          parseModelSelectAttributes();
          ToastrSvc.success('Member Information Updated');
          LoaderSvc.stop();
        });
    }

    // parse the values that require relationships
    function parseModelSelectAttributes() {
      // convert form to just array of ids
      selectAtrTypes.forEach(sat => {
        if(!that.model[sat.value]) { that.model[sat.value] = []; }
        that.model[sat.value] = that.model[sat.value].map(atrValue => {
          return atrValue.id;
        });
      });
    }

    MemAtrTypeSvc.query({groupId}).$promise
      .then(function(memAtrType) {
      // map attributes to form json object - 1 row per member attribute
        that.rows = memAtrType.map(function(mat) {
        // get select options for relationship attributes
          if(mat.responseType === 'rel') { selectAtrTypes.push(mat); }
          mat.value = 'a' + mat.id;
          return {inputs: [mat], displayOrder: mat.displayOrder};
        });
        return MemAtrSvc.get({groupId, id: that.personId}).$promise
          .then(function(memAtr) {
            that.memAtr = memAtr;
            that.model = angular.copy(memAtr);
            parseModelSelectAttributes();

            // submit function
            that.submit = submit;

            LoaderSvc.stop();
          });
      })
      .catch(function() {
        LoaderSvc.stopError('Error loading member information');
      });
  }
}

MemAtrCtrl.$inject = [
  '$stateParams',
  '$location',
  'LoaderSvc',
  'ToastrSvc',
  'MemAtrTypeSvc',
  'MemAtrSvc'
];
